import { createRoot } from "react-dom/client";
import App from "Components/App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "Components/ErrorBoundary";
import "./Styles/index.less";
import { store, persistedStore } from "Data/Redux/Store";
import initFontAwesome from "src/FontAwesome";
import { BrowserRouter } from "react-router-dom";
import initGoogleAnalytics from "src/GoogleAnalytics";

const root = document.getElementById("app");

if (!root) {
	throw new Error("Root node is undefined.");
}

initFontAwesome();
initGoogleAnalytics();

const appComponent = (
	<ErrorBoundary>
		<BrowserRouter>
			<Provider store={ store }>
				<PersistGate loading={ null } persistor={ persistedStore } >
					<App />
				</PersistGate>
			</Provider>
		</BrowserRouter>
	</ErrorBoundary>
);

createRoot(root).render(appComponent);
